(() => {
  if (customElements.get('featured-articles')) {
    return;
  }

  class FeaturedArticles extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initElements();
      this.initSlider();
    }

    initElements() {
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        mousewheel: {
          forceToAxis: true,
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
          1200: {
            spaceBetween: 16,
            slidesPerView: 4,
          },
          990: {
            slidesPerView: 3,
          },
        },
      };
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('featured-articles', FeaturedArticles);
})();
